var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRediHelthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.884 24.8676H22.2608C23.243 24.8676 24.037 24.1609 24.037 23.1787C24.037 22.362 23.4839 21.7088 22.6919 21.5096C21.559 21.2251 20.4281 21.0021 19.2446 21.0308C17.3703 21.0764 16.059 22.1211 14.5732 23.1153",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4164 14.5153C26.8555 13.1475 26.3451 11.5775 24.9118 11.1156C24.5411 10.9976 24.1476 10.9689 23.763 11.0343C23.3795 11.0997 23.0167 11.3644 22.7055 11.5983C22.3923 11.3663 22.0295 11.1027 21.6459 11.0383C21.2633 10.9728 20.8698 10.9996 20.4981 11.1156C19.0649 11.5814 18.5515 13.1475 18.9896 14.5153C19.6665 16.685 22.7055 18.1043 22.7055 18.1043C22.7055 18.1043 25.6978 16.7107 26.4164 14.5153Z",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8841 24.8988C21.5799 24.7967 22.2885 24.8998 22.9913 24.883C24.6218 24.8443 25.8994 23.4666 27.1403 22.5319C27.7747 22.0542 28.6618 22.1176 29.2228 22.6806C29.8452 23.305 29.8452 24.318 29.2228 24.9424C27.8827 26.2884 26.6983 27.5363 24.8824 28.243C22.3609 29.2233 20.0217 28.7475 17.4695 28.243C16.4813 28.0478 15.5724 28.0359 14.5723 28.0359",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2617 29.0001H13.2935C14.0825 29.0001 14.5721 28.4441 14.5721 27.6571V23.0481C14.5721 22.2601 14.0825 21.7041 13.2945 21.7041H12.2617",
    stroke: "#1570EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRediHelthIcon);
export default __webpack_public_path__ + "static/media/redi-helth-icon.52d56d2e303a0e3ef70ad261805def7a.svg";
export { ForwardRef as ReactComponent };